export class Entry {
    username!: string;
    leaderboardId!: string;
    score!: number;
    rank!: number;
    meta!: string | null;
}
